<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">油卡列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <!-- 油卡列表 开始 -->
    <div class="oilcar_list">
      <div class="oilcar_box" v-for="(item,index) in oilCardList" @click="buttonClicked ? '' : taplist(index)" id="oilCardIndexChange">
        <div class="oilcar_box_left">
          <div class="oilcar_redio">
            <!-- <input type="radio" :checked="item.checked" /> -->
            <img class="checkimg" :src="item.checked?'/static/newprojecticon/checked.png' : '/static/newprojecticon/nocheck.png'" />
          </div>
          <div class="oilcar_mesg">
            <div class="oil_car_me">{{ item.brand_str }}</div>
            <div class="oil_car_num">{{ item.card_no }}</div>
          </div>
        </div>
        <img class="oilcar_shanchu" src="/static/newprojecticon/del.png" @click.stop="tap('oilCardIndexDelete',item.id)" />
      </div>
    </div>
    <!-- 油卡列表 结束 -->
    <!-- 新增油卡 开始 -->
    <div class="page_button oilcarlist_button" @click="tap('toCardAdd')">
      <div class="page_zhifu">新增油卡</div>
    </div>
    <!-- 新增油卡 结束 -->
    <!-- 暂无信息  开始  oilcar_none-->
    <div class="page_none " v-if="oilCardList.length==0">
      <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
    </div>
    <!-- 暂无信息  结束 -->
  </div>
</template>
<script>
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        oilCardList: {}, // 接口获取油卡列表,默认为空
        oilCardIndex: 0, // 油卡指针,默认为0
        buttonClicked: false // 防止用户重复点击,默认为false
      }
    },
    created() {
      this.request('getOilCardList')
    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      tap(e, params = '') {
        switch (e) {
          case 'toCardAdd':
            this.$router.push({
              path: '/oilCardAdd'
            })
            break
          case 'oilCardIndexDelete':
            Dialog.confirm({
                title: '提示',
                message: '确认删除？',
              })
              .then(() => {
                let requestData = {
                  id: params
                }
                this.request('delOilCardList', requestData)
              })
              .catch(() => {
                return false;
              });
            break
        }
      },
      taplist(e) {
        let that = this
        var oilCardList = this.oilCardList
        if (this.buttonClicked) return
        that.buttonClickedFun(1000)
        oilCardList.map((item, index2) => item.checked = index2 === Number(e))
        that.oilCardList = oilCardList
        var oilCardItem = that.oilCardList[Number(e)]
        that.$router.push({
          name: 'oilCard',
          params: {
            oilCardItem: oilCardItem,
            topindex: 0
          }
        })

      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取油卡列表
          case 'getOilCardList':
            httper.get('user/oil-card-list', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                console.log(res.data)
                res.data.map((item, index) => item.checked = index === that.oilCardIndex)
                that.oilCardList = res.data

              } else {
                // swal({text: res.message})
                this.$toast({
                  'message': res.message,
                })
              }
            }, true)
            break

            // 删除油卡列表
          case 'delOilCardList':
            httper.get('user/del-oil-card', requestData, res => {
              if (res.code === 0) {
                window.location.reload()
              } else {
                this.$toast({
                  message: '删除失败',
                })
              }
            }, true)
            break
        }
      },

    }
  }
</script>
<style scoped>
  .oilcar_list {
    width: 90%;
    padding: 20px;
  }

  .oilcar_box {
    width: 100%;
    height: 76px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .oilcar_box_left {
    display: flex;
    align-items: center;
  }

  .oilcar_redio {
    margin-right: 10px;
    width: 14px;
    height: 14px;
  }

  .oilcar_mesg {
    display: flex;
    flex-direction: column;
  }

  .oil_car_me {
    font-size: 14px;
    font-weight: 400;
    color: rgba(54, 54, 54, 1);

  }

  .oil_car_num {
    font-size: 10px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .oilcar_shanchu {
    width: 19px;
    height: 19px;
  }
  .oilcarlist_button{
    position: fixed;
    bottom: 50px;
  }
  .checkimg{
    width: 14px;
    height: 14px;
  }
  .oilcar_none{
	  left: 35%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/oilcard/oilCardList.vue